module.exports = __webpack_public_path__ + "static/img/tooltip-orbital-duty-cycle.43bcdc6.png";